export default __webpack_public_path__ + "static/media/stepper1.77ae32d1.png";